module.exports = __webpack_public_path__ + "fonts/overvoice2.d25103a.eot";